var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('popover-info',[_c('p',[_vm._v(" "+_vm._s(_vm.$ls.Global_Popover_AdditionalInfoForInternalUse_P1)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$ls.Global_Popover_AdditionalInfoForInternalUse_P2)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }